import { api } from '../utils'

export const uploadFile = (file: any) => api.upload('/media', file)

export const openMedia = (filename: string) => api.get(`/media/${filename}/url`)
export const downloadMedia = (filename: string) =>
  api.get(`/media/${filename}/download`)
